module.exports = __webpack_public_path__ + "media/images/white-square-ca2ae5c34be5b6d1216564cea8a49334.jpg";